import "./coupons.css";
import Layout from "../../layout";
import CouponsCard from "../../components/coupons_card";
import { Button } from "antd/lib";
import Modal from "antd/lib/modal";
import Input from "antd/lib/input";
import Select from "antd/lib/select";
import DatePicker from "antd/lib/date-picker";
import { IoClose } from "react-icons/io5";
import useCoupons from "../../hooks/use_coupons";
import { useEffect } from "react";
import { PromotionsEnum } from "../../utils/enums";
import { useDispatch, useSelector } from "react-redux";
import { setCreateCouponModal } from "../../features/app/app_slice";
import moment from "moment";
import Skeleton from "../../components/skeleton";
import Empty from "antd/lib/empty";
import Switch from "antd/lib/switch";

const Coupons = () => {
  const dispatch = useDispatch();
  const {
    // entity methods
    getCourses,
    getCoupons,
    // controller methods
    createCouponController,
    updateCouponController,
    // entity states
    courses,
    couponsData,
    // controller states
    updateModal,
    setUpdateModal,
    // loading states
    loadings,
    getCoursesLoading,
  } = useCoupons();

  const userProfile = useSelector((state) => state.app.userProfile);
  const createCouponModal = useSelector((state) => state.app.createCouponModal);

  useEffect(() => {
    if (userProfile) {
      getCourses();
      getCoupons();
    }
  }, [userProfile]);

  useEffect(() => {
    if (!createCouponModal) {
      createCouponController.resetForm();
    }
  }, [createCouponModal]);

  useEffect(() => {
    if (!updateModal) {
      updateCouponController.resetForm();
    }
  }, [updateModal]);

  useEffect(() => {
    createCouponController.setValues(createCouponController.values);
  }, [createCouponController.values]);

  return (
    <Layout>
      <div className="coupons">
        <h3>Coupons</h3>
        <div className="coupons_container">
          {loadings.getCoupons
            ? Array(2)
                .fill()
                .map((item, index) => (
                  <Skeleton
                    key={index}
                    style={{ width: "100%", height: 330, borderRadius: 8 }}
                  />
                ))
            : couponsData.map((coupon, index) => (
                <CouponsCard
                  data={coupon}
                  setUpdateModal={setUpdateModal}
                  updateCouponController={updateCouponController}
                />
              ))}
        </div>
        {!loadings.getCoupons && couponsData.length == 0 ? (
          <Empty
            description="No coupons founded"
            style={{
              width: "100%",
              padding: "48px 0",
            }}
          />
        ) : null}
        <div className="create_coupon_modal_btn">
          <Button
            onClick={() => {
              dispatch(setCreateCouponModal(true));
            }}
          >
            Add new coupon
          </Button>
        </div>
      </div>
      {/* create coupon modal */}
      <Modal
        open={createCouponModal}
        onCancel={() => {
          dispatch(setCreateCouponModal(false));
        }}
        footer={null}
        className="createCouponModal"
        closeIcon={null}
      >
        <div className="create_coupon_modal_container">
          <div className="create_coupon_modal_title">
            <Button
              onClick={() => {
                dispatch(setCreateCouponModal(false));
              }}
            >
              <IoClose />
            </Button>
            <h3>New Coupon</h3>
          </div>
          <form
            onSubmit={createCouponController.handleSubmit}
            className="create_coupon_form"
          >
            <div className="code_description_form">
              {/* code */}
              <div className="code_form">
                <label htmlFor="code">Code</label>
                <Input
                  name="code"
                  id="code"
                  value={createCouponController.values.code}
                  onChange={createCouponController.handleChange}
                  disabled={loadings.createCoupon}
                  status={
                    createCouponController.touched.code &&
                    createCouponController.errors.code
                      ? "error"
                      : ""
                  }
                />
              </div>
              {/* usageLimit */}
              <div className="usage_limit">
                <label htmlFor="usageLimit">Usage Limit</label>
                <Input
                  value={createCouponController.values.usageLimit}
                  onChange={createCouponController.handleChange}
                  status={
                    createCouponController.touched.usageLimit &&
                    createCouponController.errors.usageLimit
                      ? "error"
                      : ""
                  }
                  disabled={loadings.createCoupon}
                  id="usageLimit"
                  name="usageLimit"
                  type="tel"
                />
              </div>
            </div>
            <div className="discount_type_discount_value">
              {/* type */}
              <div className="discount_type">
                <label htmlFor="type">Discount Type</label>
                <Select
                  options={PromotionsEnum}
                  id="type"
                  value={createCouponController.values.type}
                  onChange={(value) => {
                    createCouponController.setFieldValue("type", value);
                  }}
                  disabled={loadings.createCoupon}
                />
              </div>
              {/* amount */}
              <div className="discount_value">
                <label htmlFor="amount">Discount Value</label>
                <Input
                  suffix="%"
                  value={createCouponController.values.amount}
                  onChange={createCouponController.handleChange}
                  status={
                    createCouponController.touched.amount &&
                    createCouponController.errors.amount
                      ? "error"
                      : ""
                  }
                  disabled={loadings.createCoupon}
                  id="amount"
                  name="amount"
                  type="tel"
                />
              </div>
            </div>
            <div className="start_end_date">
              {/* startDate */}
              <div className="start_date">
                <label htmlFor="startDate">Start Date</label>
                <DatePicker
                  value={createCouponController.values.startDate}
                  onChange={(date) => {
                    createCouponController.setFieldValue("startDate", date);
                  }}
                  disabledDate={(current) => {
                    return current && current < moment().startOf("day");
                  }}
                  disabled={loadings.createCoupon}
                  name="startDate"
                  id="startDate"
                />
              </div>
              {/* endDate */}
              <div className="end_date">
                <label htmlFor="endDate">End Date</label>
                <DatePicker
                  value={createCouponController.values.endDate}
                  onChange={(date) => {
                    createCouponController.setFieldValue("endDate", date);
                  }}
                  disabledDate={(current) => {
                    return current && current < moment().startOf("day");
                  }}
                  disabled={loadings.createCoupon}
                  name="endDate"
                  id="endDate"
                />
              </div>
            </div>
            <div className="discount_type_discount_value desc_form_container">
              {/* description */}
              <div className="desc_form">
                <label htmlFor="description">Description</label>
                <Input
                  rows={3}
                  name="description"
                  id="description"
                  value={createCouponController.values.description}
                  onChange={createCouponController.handleChange}
                  disabled={loadings.createCoupon}
                  status={
                    createCouponController.touched.description &&
                    createCouponController.errors.description
                      ? "error"
                      : ""
                  }
                />
              </div>
              {/* courseIds */}
              <div className="discount_type">
                <label htmlFor="courseIds">Courses</label>
                <Select
                  mode="multiple"
                  value={createCouponController.values.courseIds}
                  onChange={(value) => {
                    createCouponController.setFieldValue("courseIds", value);
                  }}
                  loading={getCoursesLoading}
                  disabled={getCoursesLoading || loadings.createCoupon}
                  onClear={(value) => {
                    createCouponController.setFieldValue("courseIds", []);
                  }}
                  showSearch={false}
                  allowClear
                  options={courses
                    .filter((o) => o.status == 1)
                    .map((item) => {
                      return { label: item.name, value: item.id };
                    })}
                />
              </div>
            </div>
            {/* isActive */}
            <div className="coupons_card_active">
              <span>Active</span>
              <Switch
                checked={createCouponController.values.isActive}
                onClick={(checked) => {
                  createCouponController.setFieldValue("isActive", checked);
                }}
              />
            </div>
            <div className="usage_limit_applicable"></div>
            <div className="cancel_save_btn_form">
              <Button
                onClick={() => {
                  dispatch(setCreateCouponModal(false));
                }}
                disabled={loadings.createCoupon}
              >
                Cancel
              </Button>
              <Button htmlType="submit" loading={loadings.createCoupon}>
                Post
              </Button>
            </div>
            <div className="cancel_save_btn_form_mobile">
              <Button htmlType="submit" loading={loadings.createCoupon}>
                Confirm
              </Button>
            </div>
          </form>
        </div>
      </Modal>
      {/* update coupon modal */}
      <Modal
        open={updateModal}
        onCancel={() => {
          setUpdateModal(false);
        }}
        footer={null}
        className="createCouponModal"
        closeIcon={null}
      >
        <div className="create_coupon_modal_container">
          <div className="create_coupon_modal_title">
            <Button
              onClick={() => {
                setUpdateModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Update Coupon</h3>
          </div>
          <form
            onSubmit={updateCouponController.handleSubmit}
            className="create_coupon_form"
          >
            <div className="code_description_form">
              {/* code */}
              <div className="code_form">
                <label htmlFor="code">Code</label>
                <Input
                  name="code"
                  id="code"
                  value={updateCouponController.values.code}
                  onChange={updateCouponController.handleChange}
                  disabled={true}
                  status={
                    updateCouponController.touched.code &&
                    updateCouponController.errors.code
                      ? "error"
                      : ""
                  }
                />
              </div>
              {/* usageLimit */}
              <div className="usage_limit">
                <label htmlFor="usageLimit">Usage Limit</label>
                <Input
                  value={updateCouponController.values.usageLimit}
                  onChange={updateCouponController.handleChange}
                  status={
                    updateCouponController.touched.usageLimit &&
                    updateCouponController.errors.usageLimit
                      ? "error"
                      : ""
                  }
                  disabled={loadings.updateCoupon}
                  id="usageLimit"
                  name="usageLimit"
                  type="tel"
                />
              </div>
            </div>
            <div className="start_end_date">
              {/* startDate */}
              <div className="start_date">
                <label htmlFor="startDate">Start Date</label>
                <DatePicker
                  value={updateCouponController.values.startDate}
                  onChange={(date) => {
                    updateCouponController.setFieldValue("startDate", date);
                  }}
                  disabledDate={(current) => {
                    return current && current < moment().startOf("day");
                  }}
                  format="YYYY-MM-DD"
                  disabled={loadings.updateCoupon}
                  name="startDate"
                  id="startDate"
                />
              </div>
              {/* endDate */}
              <div className="end_date">
                <label htmlFor="endDate">End Date</label>
                <DatePicker
                  value={updateCouponController.values.endDate}
                  onChange={(date) => {
                    updateCouponController.setFieldValue("endDate", date);
                  }}
                  disabledDate={(current) => {
                    return current && current < moment().startOf("day");
                  }}
                  format="YYYY-MM-DD"
                  disabled={loadings.updateCoupon}
                  name="endDate"
                  id="endDate"
                />
              </div>
            </div>
            <div className="discount_type_discount_value desc_form_container">
              {/* description */}
              <div className="desc_form">
                <label htmlFor="description">Description</label>
                <Input
                  rows={3}
                  name="description"
                  id="description"
                  value={updateCouponController.values.description}
                  onChange={updateCouponController.handleChange}
                  disabled={loadings.updateCoupon}
                  status={
                    updateCouponController.touched.description &&
                    updateCouponController.errors.description
                      ? "error"
                      : ""
                  }
                />
              </div>
              {/* courseIds */}
              <div className="discount_type">
                <label htmlFor="courseIds">Courses</label>
                <Select
                  mode="multiple"
                  value={updateCouponController.values.courseIds}
                  onChange={(value) => {
                    updateCouponController.setFieldValue("courseIds", value);
                  }}
                  loading={getCoursesLoading}
                  disabled={getCoursesLoading || loadings.updateCoupon}
                  onClear={(value) => {
                    updateCouponController.setFieldValue("courseIds", []);
                  }}
                  showSearch={false}
                  allowClear
                  options={courses
                    .filter((o) => o.status == 1)
                    .map((item) => {
                      return { label: item.name, value: item.id };
                    })}
                />
              </div>
            </div>
            {/* isActive */}
            <div className="coupons_card_active">
              <span>Active</span>
              <Switch
                checked={updateCouponController.values.isActive}
                onClick={(checked) => {
                  updateCouponController.setFieldValue("isActive", checked);
                }}
                disabled={loadings.updateCoupon}
              />
            </div>
            <div className="usage_limit_applicable"></div>
            <div className="cancel_save_btn_form">
              <Button
                onClick={() => {
                  dispatch(setCreateCouponModal(false));
                }}
                disabled={loadings.updateCoupon}
              >
                Cancel
              </Button>
              <Button htmlType="submit" loading={loadings.updateCoupon}>
                Save Changes
              </Button>
            </div>
            <div className="cancel_save_btn_form_mobile">
              <Button htmlType="submit" loading={loadings.updateCoupon}>
                Save Changes
              </Button>
            </div>
          </form>
        </div>
      </Modal>
    </Layout>
  );
};

export default Coupons;
